/* Func = limiting Scope for this file */
var lastScrollTop = 0;

let logo;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getAccommodationByTag( tag, holder, module, title_style, specs_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getAccommodationByTag');
	FORM_DATA.append('tag', tag);
	FORM_DATA.append('title_style', title_style);
	FORM_DATA.append('specs_style', specs_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
			initAllSwipers();
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageAccommodationModule(){
	const ALL_ACCOMMODATIONS_MODULE = document.querySelectorAll(`.js-accommodations`);

	ALL_ACCOMMODATIONS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-accommodations_filter'),
			holder = module.querySelector('.js-accommodations_holder'),
			selectorOnMobile = module.querySelector('.js-accommodations_selector'),
			title_style = holder.dataset.title_style,
			specs_style = holder.dataset.specs_style,
			beforeOptionActive = null;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getAccommodationByTag( elementClicked.dataset.tag, holder, module, title_style, specs_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function getDinginMenu( menu_id, holder, module ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getDinginMenu');
	FORM_DATA.append('menu_id', menu_id);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageDiningMenusModule(){
	const ALL_MENUS_MODULE = document.querySelectorAll(`.js-menusQuad`);

	ALL_MENUS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-menusQuad_filter'),
			holder = module.querySelector('.js-menusQuad_holder'),
			selectorOnMobile = module.querySelector('.js-menusQuad_selector'),
			beforeOptionActive = null;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getDinginMenu( elementClicked.dataset.menu, holder, module );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function manageDiningMenusIAModule() {
    const modules = document.querySelectorAll('.js-menusQuadIA');

    modules.forEach(module => {
        const tabList = module.querySelector('[role="tablist"]');
        if (!tabList) return;

        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0) return;

        const panels = tabs.map(tab => {
            const targetId = tab.getAttribute('aria-controls');
            return targetId ? module.querySelector(`#${targetId}`) : null;
        });

        const isMobileScreen = window.innerWidth <= 768;

        if (isMobileScreen) {
            tabList.style.display = 'none';

            let mobileSelect = module.querySelector('.js-menusQuad_mobileSelect');
            if (!mobileSelect) {
                mobileSelect = document.createElement('select');
                mobileSelect.className = 'menusQuadIA_select js-menusQuad_mobileSelect';
                mobileSelect.setAttribute('aria-label', 'Select Menu');

                tabs.forEach((tab, index) => {
                    const option = document.createElement('option');
                    option.value = index;
                    option.textContent = tab.textContent.trim();
                    if (tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('is-active')) {
                        option.selected = true;
                    }
                    mobileSelect.appendChild(option);
                });

                tabList.parentNode.insertBefore(mobileSelect, tabList);
            }

            function activateMobileTab(index) {
                panels.forEach((panel, i) => {
                    if (!panel) return;
                    if (i === index) {
                        panel.removeAttribute('hidden');
                        panel.style.display = 'block';
                    } else {
                        panel.setAttribute('hidden', '');
                        panel.style.display = 'none';
                    }
                });
            }

            mobileSelect.addEventListener('change', (e) => {
                activateMobileTab(parseInt(e.target.value, 10));
            });

            const initialIndex = mobileSelect.selectedIndex >= 0 ? mobileSelect.selectedIndex : 0;
            activateMobileTab(initialIndex);

        } else {
            function activateTab(index) {
                tabs.forEach((tab, i) => {
                    const isActive = i === index;
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', isActive ? '0' : '-1');
                    tab.classList.toggle('is-active', isActive);
                });

                panels.forEach((panel, i) => {
                    if (!panel) return;
                    if (i === index) {
                        panel.removeAttribute('hidden');
                        panel.style.display = 'block';
                    } else {
                        panel.setAttribute('hidden', '');
                        panel.style.display = 'none';
                    }
                });
            }

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => activateTab(index));

                tab.addEventListener('keydown', (e) => {
                    let newIndex = index;
                    switch (e.key) {
                        case 'ArrowRight':
                            newIndex = (index + 1) % tabs.length;
                            break;
                        case 'ArrowLeft':
                            newIndex = (index - 1 + tabs.length) % tabs.length;
                            break;
                        case 'Home':
                            newIndex = 0;
                            break;
                        case 'End':
                            newIndex = tabs.length - 1;
                            break;
                        default:
                            return;
                    }
                    e.preventDefault();
                    activateTab(newIndex);
                    tabs[newIndex].focus();
                });
            });

            const initialActiveIndex = tabs.findIndex(tab => 
                tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('is-active')
            );
            activateTab(initialActiveIndex !== -1 ? initialActiveIndex : 0);
        }
    });
}

function getVenues( venue_location, venue_type, holder, module, globalCtaLink, globalCtaLabel, title_style, specs_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getVenues');
	FORM_DATA.append('venue_location', venue_location);
	FORM_DATA.append('venue_type', venue_type);
	FORM_DATA.append('globalCtaLink', globalCtaLink);
	FORM_DATA.append('globalCtaLabel', globalCtaLabel);
	FORM_DATA.append('title_style', title_style);
	FORM_DATA.append('specs_style', specs_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageVenuesModule(){
	const ALL_MENUS_MODULE = document.querySelectorAll(`.js-venues`);

	ALL_MENUS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-venues_filter'),
			holder = module.querySelector('.js-venues_holder'),
			selectorOnMobile = module.querySelector('.js-venues_selector'),
			beforeOptionActive = null,
			title_style = holder.dataset.title_style,
			specs_style = holder.dataset.specs_style,
			globalCtaLink = holder.dataset.globalctalink,
			globalCtaLabel = holder.dataset.globalctalabel;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getVenues( elementClicked.dataset.venue_location, elementClicked.dataset.venue_type, holder, module, globalCtaLink, globalCtaLabel, title_style, specs_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function getOffers( tag, holder, module, title_style, subtitle_style, dates_style ){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getOffers');
	FORM_DATA.append('tag', tag);
	FORM_DATA.append('title_style', title_style);
	FORM_DATA.append('subtitle_style', subtitle_style);
	FORM_DATA.append('dates_style', dates_style);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
		}
	})
	.catch((error) => {
		console.log(error);
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageOffersModule(){
	const ALL_OFFERS_MODULE = document.querySelectorAll(`.js-offers`);

	ALL_OFFERS_MODULE.forEach( module => {
		let filter = module.querySelector('.js-offers_filter'),
			holder = module.querySelector('.js-offers_holder'),
			selectorOnMobile = module.querySelector('.js-offers_selector'),
			title_style = holder.dataset.title_style,
			subtitle_style = holder.dataset.subtitle_style,
			dates_style = holder.dataset.dates_style,
			beforeOptionActive = null;

		filter.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'LI' ){
				if( beforeOptionActive )
					beforeOptionActive.classList.remove('active');

				getOffers( elementClicked.dataset.tag, holder, module, title_style, subtitle_style, dates_style );

				elementClicked.classList.add('active');
				beforeOptionActive = elementClicked;

				if( window.innerWidth < 641 ){
					selectorOnMobile.classList.remove("active")
					selectorOnMobile.textContent = elementClicked.textContent;
				}
			}
		} );

		filter.querySelector('li').click();

		if( window.innerWidth < 641 ){
			selectorOnMobile.addEventListener("click", () => {
				selectorOnMobile.classList.toggle("active");
			})
		}
	} );
}

function getEventsCalendar({ searchBar, month, category, type, view, holder, module }){
	const FORM_DATA = new FormData();

	FORM_DATA.append('operation', 'getEventsCalendar');
	FORM_DATA.append('searchBar', searchBar);
	FORM_DATA.append('month', month);
	FORM_DATA.append('category', category);
	FORM_DATA.append('type', type);
	FORM_DATA.append('view', view);

	fetch(`${site_url}/ajax/functions.php`, { 
		method: 'POST',
		body: FORM_DATA 
	})
	.then((response) => response.json())
	.then((data) => {
		if( data.err == true ){
			console.error(`Something went wrong with the module ${module.id};\n ${data.err_msg}`);
		}else{
			holder.innerHTML = data.html;
			document.querySelectorAll(`[data-lbx]`).forEach(lbxCTA => {
				lbxCTA.addEventListener("click", () => {
					let dataDayFromCTA = lbxCTA.dataset.day;
					let lookForLbxBox = setInterval(() => {
						let lbxBox = document.querySelector(`[data-lbx-id="${lbxCTA.hash}"]`);
						if( lbxBox ){
							clearInterval(lookForLbxBox);

							lbxBox.querySelectorAll(`.event_lightbox__item`).forEach( item => item.setAttribute('style', 'display:none') );
							lbxBox.querySelectorAll(`[data-day="${dataDayFromCTA}"]`).forEach( item => item.setAttribute('style', 'display:block') );
						}
					}, 100);
				})
			});
		}
	})
	.catch((error) => {
		console.log(error);
		console.error(`Something went wrong with the module ${module.id};\n ${error}`);
	});
}

function manageEventsCalendarModule(){
	const ALL_EVENTS_CALENDAR_MODULE = document.querySelectorAll(`.js-events`);

	const mapOptionsSelected = (filter, state) => {
		if( !filter || !state )
			return {};

		let searchBarValue = filter.querySelector(".js-events_search").value,
			monthValue = filter.querySelector(".js-events_months span").dataset.value,
			categoryValue = filter.querySelector(".js-events_categories span").dataset.value,
			typeValue = filter.querySelector(".js-events_type span").dataset.value

		state.searchBar = searchBarValue;
		state.month = monthValue;
		state.category = categoryValue;
		state.type = typeValue;

		return state;
	}

	ALL_EVENTS_CALENDAR_MODULE.forEach( module => {
		let filter = module.querySelector('.js-events-filter'),
			holder = module.querySelector('.js-events_holder'),
			reset = module.querySelector('.js-events-reset'),
			views = module.querySelector('.js-events_views'),
			beforeViewActive = null
		const filterState = { 
				searchBar : '',
				month: '',
				category : '',
				type : '',
				view: '',
				holder: holder,
				module: module
			};

		mapOptionsSelected(filter, filterState);
		
		module.querySelectorAll('.events_select').forEach( select => {
			select.addEventListener("click", (e) => {
				let elementClicked = e.target;

				if( elementClicked.nodeName == "SPAN" ){
					select.classList.toggle("active");
				}
				
				if( elementClicked.nodeName == "LI" ){
					select.classList.remove("active");
					select.querySelector('span').textContent = elementClicked.textContent;
					select.querySelector('span').dataset.value = elementClicked.dataset.value;
					mapOptionsSelected(filter, filterState);
					getEventsCalendar( filterState );
				}
			})
		} )

		module.querySelectorAll("input").forEach( input => {
			input.addEventListener("input", (e) => {
				mapOptionsSelected(filter, filterState);
				getEventsCalendar( filterState );
			})
		} )
		
		reset.addEventListener("click", () => {
			module.querySelectorAll('.events_select').forEach( select => {
				select.querySelector('span').textContent = select.querySelector('li').textContent;
				select.querySelector('span').dataset.value = select.querySelector('li').dataset.value;
			});
			mapOptionsSelected(filter, filterState);
			getEventsCalendar( filterState );
		})

		views.addEventListener( 'click', event => {
			let elementClicked = event.target;
			if( elementClicked.nodeName == 'BUTTON' && !elementClicked.classList.contains('js-events-reset') ){
				filterState.view = elementClicked.dataset.view;
				if( beforeViewActive )
					beforeViewActive.classList.remove('active');

				getEventsCalendar( filterState );

				elementClicked.classList.add('active');
				beforeViewActive = elementClicked;
			}
		} );

		views.querySelector('button').click();
	} );
}

function manageMenuOnBurger(){
	let itemsMenu = document.querySelectorAll('.principalMenu .privary-navigation .privary-navigation__item, .navigation.overlay .inner ul li');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('click',(e)=>{
				let elementClicked = e.target.nodeName == 'A' ? e.target.parentNode : e.target;
				let currentItemActive = document.querySelector(`.privary-navigation .privary-navigation__item.hover`);
				if( currentItemActive && itemMenu != currentItemActive ){
					currentItemActive.classList.remove('hover');
					currentItemActive.querySelector('.submenu').classList.toggle('show');
				}

				if( elementClicked.querySelector('.submenu') || elementClicked.nextElementSibling.classList.contains('submenu') ){
					e.preventDefault();
					itemMenu.classList.toggle('hover');
					itemMenu.querySelector('.submenu').classList.toggle('show');
				}
			});
		}
	})
}

function manageSelectorLangs(){
	const ALL_LANG_SELECTORS = document.querySelectorAll(`.js-langs`);

	ALL_LANG_SELECTORS.forEach( selector => {
		let currentLang = document.querySelector(`.js-langs_current`),
			listLangs = document.querySelector(`.js-langs_list`);

		currentLang.addEventListener("click", () => {
			selector.classList.toggle("opened");
		})
	} );
}

function manageMenuUnderHeader(){
	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})
}

function managePrimaryNavFirstTemplate(){
	let principalMenu = document.querySelector(`.js-principalMenu`),
		openMenuCTA = document.querySelectorAll(`.js-principalMenu_open`),
		closeMenuCTA = document.querySelectorAll(`.js-principalMenu_close`);

	openMenuCTA.forEach( cta => { 
		cta.addEventListener( "click", event => {
			event.preventDefault();
			principalMenu.classList.add("open");
		} );
	 } );

	closeMenuCTA.forEach( cta => {
		cta.addEventListener( "click", event => {
			event.preventDefault();
			principalMenu.classList.remove("open");
		} );
	} );
}

function insertSymClassOnForm(){
	const ALL_FORMS = document.querySelectorAll(`.form-module`);

	ALL_FORMS.forEach( form => {
		let allTextHTMLTags = form.querySelectorAll('h1, h2, h3, h4, h5, h6, p'); 
		allTextHTMLTags.forEach( element => {
			if( element.nodeName == 'P' ){
				element.classList.add(`sym-paragraph`)
			}else{
				element.classList.add(`sym-${element.nodeName.toLowerCase()}`)
			}
		} )
	} );
}

function scrollW(){
	let image_logo = logo.querySelector('img');
	let logo_default = image_logo.dataset.default,
		logo_scroll = image_logo.dataset.scroll;

	/*check scroll down or up for header styles*/
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		image_logo.src = logo_scroll;
		if (st > lastScrollTop){
			/* downscroll code */
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			/* upscroll code */
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		image_logo.src = logo_default;
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

	if( 
		document.querySelector(`.top-content.no-topContentImage`) || 
		document.querySelector(`body#attractions`) || 
		document.querySelector(`body#gallery-grid`) || 
		document.querySelector(`body#gallery-flex`) ||
		document.querySelector(`body#contact-us.no-topContentImage`)
	){
		image_logo.src = logo_scroll;
	}

	let submenu = document.querySelector(`.sub-menu`);
	let heightHeader = document.getElementById('header').getBoundingClientRect().height;
	if( submenu && heightHeader ){
		if( submenu.getBoundingClientRect().top < heightHeader ){
			submenu.classList.add('fixedUnderHeader');
		}else if( submenu.getBoundingClientRect().top > heightHeader && submenu.classList.contains('fixedUnderHeader') ){
			submenu.classList.remove('fixedUnderHeader');
		}
	}
}

(function(){

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    /* Remove empty <p> tags created by tinymce */
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	logo = document.querySelector(`.js-scroll-logo`);

	if( document.querySelector(`.principalMenu`) )
		managePrimaryNavFirstTemplate();
	
	if( document.querySelector(`.header_bottom`) && document.querySelector(`.header_bottom .privary-navigation`) )
		manageMenuUnderHeader();

	if( document.querySelector(`.principalMenu`) && (document.querySelector(`.principalMenu .privary-navigation`) || document.querySelector(`.principalMenu .navigation.overlay`)) )
		manageMenuOnBurger();

	if( document.querySelector(`.js-langs`) )
		manageSelectorLangs();

	if( document.querySelector(`.js-accommodations`) )
		manageAccommodationModule();

	if( document.querySelector(`.js-menusQuad`) )
		manageDiningMenusModule();
	
	if( document.querySelector(`.js-menusQuadIA`) )
		manageDiningMenusIAModule();

	if( document.querySelector(`.js-venues`) )
		manageVenuesModule();

	if( document.querySelector(`.js-offers`) )
		manageOffersModule();

	if( document.querySelector(`.js-events`) )
		manageEventsCalendarModule();

	if( document.querySelector(`.form-module`) )
		insertSymClassOnForm();
})();